import * as React from "react";

const GVLeftArrow: React.FC = () => {
    return (
        <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.146447 3.32845C-0.0488155 3.52372 -0.0488156 3.8403 0.146447 4.03556L3.32843 7.21754C3.52369 7.4128 3.84027 7.4128 4.03553 7.21754C4.2308 7.02228 4.2308 6.7057 4.03553 6.51043L1.20711 3.68201L4.03553 0.85358C4.2308 0.658318 4.2308 0.341735 4.03553 0.146473C3.84027 -0.048789 3.52369 -0.048789 3.32843 0.146473L0.146447 3.32845ZM16.5 4.18201C16.7761 4.18201 17 3.95815 17 3.68201C17 3.40587 16.7761 3.18201 16.5 3.18201L16.5 3.68201L16.5 4.18201ZM0.5 3.68201L0.5 4.18201L16.5 4.18201L16.5 3.68201L16.5 3.18201L0.5 3.18201L0.5 3.68201Z" fill="#1C1917"/>
        </svg>
    );
};

export default React.memo(GVLeftArrow);




